export const invoices = state => state.getIn(['invoices', 'entities']);
export const invoiceById = (state, id) => invoices(state).get(String(id));
export const invoicesByIds = (state, ids) => ids.map(id => invoiceById(state, id));
